import {css} from "@panda/css";
import cn from "classnames";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {creditContributionDefault} from "../constants/credit_contribution_default";
import {creditPeriodDefault} from "../constants/credit_period_default";
import {calculateInstallment} from "../utils/calculate_installment";
import {replaceDigitsWithZeros} from "../utils/replace_digits_with_zeros";

interface IProps {
    price: number | null;
    className?: string;
    currency: Currency;
    shouldBlur?: boolean;
}

export const CreditEstimatedValue = (props: IProps) => {
    const {shouldBlur = false} = props;
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    if (!props.price) {
        return null;
    }
    const calculatedInstallment = calculateInstallment(props.price, creditContributionDefault, creditPeriodDefault);

    if (!calculatedInstallment) {
        return null;
    }

    const formattedInstallment = priceFormat(calculatedInstallment, {unit: currencyUnit});
    const displayValue = shouldBlur ? replaceDigitsWithZeros(formattedInstallment ?? "") : formattedInstallment || "";

    return (
        <div className={cn(estimatePriceInfo, props.className)}>
            <BrandCoinIcon size="1.6" wrapperSize="1.6" />
            <Text variant="body_copy_2">
                Estymowana rata kredytu: <b>{displayValue}</b>
            </Text>
        </div>
    );
};

const estimatePriceInfo = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    mt: 0.5
});
import {css} from "@panda/css";
import cn from "classnames";

import {BrandCoinIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {creditContributionDefault} from "../constants/credit_contribution_default";
import {creditPeriodDefault} from "../constants/credit_period_default";
import {calculateInstallment} from "../utils/calculate_installment";
import {replaceDigitsWithZeros} from "../utils/replace_digits_with_zeros";

interface IProps {
    price: number | null;
    className?: string;
    currency: Currency;
    shouldBlur?: boolean;
}

export const CreditEstimatedValue = (props: IProps) => {
    const {shouldBlur = false} = props;
    const currencyUnit = props.currency === Currency.EURO ? "eur" : "zł";
    if (!props.price) {
        return null;
    }
    const calculatedInstallment = calculateInstallment(props.price, creditContributionDefault, creditPeriodDefault);

    if (!calculatedInstallment) {
        return null;
    }

    const formattedInstallment = priceFormat(calculatedInstallment, {unit: currencyUnit});
    const displayValue = shouldBlur ? replaceDigitsWithZeros(formattedInstallment ?? "") : formattedInstallment || "";

    return (
        <div className={cn(estimatePriceInfo, props.className)}>
            <BrandCoinIcon size="1.6" wrapperSize="1.6" />
            <Text variant="body_copy_2">
                Estymowana rata kredytu: <b>{displayValue}</b>
            </Text>
        </div>
    );
};

const estimatePriceInfo = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5,
    mt: 0.5
});
